module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('van-cell-group', [_c('van-cell', {
    attrs: {
      "title": _vm.express.company_name,
      "label": "物流跟踪"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.express.num) + "\n            "), _c('span', {
    staticStyle: {
      "color": "#0076FF"
    }
  }, [_c('button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.express.num),
      expression: "express.num",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopy),
      expression: "onCopy",
      arg: "success"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:error",
      value: (_vm.onError),
      expression: "onError",
      arg: "error"
    }],
    staticClass: "btn",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("\n                            复制\n                        ")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "express-trace-detail"
  }, [_c('div', _vm._l((_vm.list), function(item, index) {
    return _c('div', [_c('div', {
      staticClass: "time-item"
    }, [_c('div', [_vm._v("\n                        " + _vm._s(item.title) + "\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "time"
    }, [_vm._v("\n                        " + _vm._s(item.create_time_format) + "\n                    ")])])])
  }), 0)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-74168c3a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/order/ExpressTrace.vue
// module id = 2465
// module chunks = 0